import terminalsApi from 'Api/axios/terminals-api';
import { useState, useEffect } from 'react';
import type { TerminalFilterI, TerminalI } from 'types';

interface Props {
  init?: boolean;
}

const useTerminalsApi = ({ init = false }: Props = {}) => {
  const [data, setData] = useState<Array<TerminalI>>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const fetchTerminals = async (filters: TerminalFilterI = {}) => {
    setLoading(true);
    const response = await terminalsApi.readAll(filters);
    setData(response.data ?? []);
    setLoading(false);
    setError(response.error);
  };

  useEffect(() => {
    if (init) {
      fetchTerminals();
    }
  }, [init]);

  return {
    data,
    loading,
    error,
    fetchTerminals,
  };
};

export default useTerminalsApi;
